const commonOption = [
  {
    title: 'is equal to',
    value: 'IsEqualTo',
  },
  {
    title: 'is not equal to',
    value: 'IsNotEqualTo',
  },
];

export const filterOptionsString = [
  ...commonOption,
  {
    title: 'start with',
    value: 'StartsWith',
  },
  {
    title: 'contains',
    value: 'Contains',
  },
  {
    title: 'does not contain',
    value: 'DoesNotContains',
  },
  {
    title: 'ends with',
    value: 'EndsWith',
  },
];

export const filterOptionsNumber = [
  ...commonOption,
  {
    title: 'is greater than or equal to',
    value: 'GreaterThanOrEqualTo',
  },
  {
    title: 'is greater than',
    value: 'GreaterThan',
  },
  {
    title: 'is less than or equal to',
    value: 'LessThanOrEqualTo',
  },
  {
    title: 'is less than',
    value: 'LessThan',
  },
];
